/*
 *
 * DisableVasPopup
 *
 * @version 1.0.0
 * @author Andrea Pinardi
 * @since 19-May-2025
 */

import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  deactivationTitle: {
    id: 't.app.terminalsManagement.disputeless.serviceConfig.deactivationTitle',
    defaultMessage: 'Disable the service'
  },
  description_Disputeless: {
    id: 't.app.terminalsManagement.disputeless.serviceConfig.description',
    defaultMessage:
      'The "Disputeless" service has as its object the provision and management, by Nexi, of a service that allows the Merchant to make a guided and secure payment method available to his customer, thus improving the transparency of the services offered'
  },
  description_ClickAndCollect: {
    id: 't.app.terminalsManagement.clickNCollect.details.description',
    defaultMessage:
      'Omnichannel service enabling “Click & Collect” purchases, purchases initiated online that can be completed at a physical store.'
  },
  description_PosTokenization: {
    id: 't.app.terminalsManagement.posTokenization.details.description',
    defaultMessage:
      'Omnichannel service enabling creation of recurring payments contracts (tokenization) at physical POS terminals. Tokens can be used for debits and OneClick e-commerce payments.'
  },
  confirm: {
    id: 't.app.project.btn.confirm',
    defaultMessage: 'Confirm'
  },
  close: {
    id: 't.app.project.btn.close',
    defaultMessage: 'Close'
  }
})
